export enum DialogType {
  OVERTIME = 'overtime',
  COINBALANCE = 'coinbalance',
}
